import { useTranslation } from "react-i18next";
import { ClipboardList, Smartphone, FileBarChart, ArrowRight } from "lucide-react";
import { ScrollReveal } from "./ScrollReveal";
import {
  ChecklistEditorIllustration,
  MobileInspectionIllustration,
  PdfReportIllustration,
} from "./BlueprintIllustrations";

const steps = [
  {
    icon: ClipboardList,
    titleKey: "landing.process.step1.title",
    descKey: "landing.process.step1.description",
    Illustration: ChecklistEditorIllustration,
    altKey: "landing.process.step1.illustrationAlt",
    testId: "process-illustration-step1",
  },
  {
    icon: Smartphone,
    titleKey: "landing.process.step2.title",
    descKey: "landing.process.step2.description",
    Illustration: MobileInspectionIllustration,
    altKey: "landing.process.step2.illustrationAlt",
    testId: "process-illustration-step2",
  },
  {
    icon: FileBarChart,
    titleKey: "landing.process.step3.title",
    descKey: "landing.process.step3.description",
    Illustration: PdfReportIllustration,
    altKey: "landing.process.step3.illustrationAlt",
    testId: "process-illustration-step3",
  },
];

export function ProcessFlow() {
  const { t } = useTranslation();

  return (
    <section className="py-24 bg-background">
      <div className="container mx-auto px-6">
        <ScrollReveal>
          <div className="text-center mb-16 space-y-4">
            <h2 className="text-3xl sm:text-4xl font-bold text-foreground">
              {t("landing.process.title")}
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              {t("landing.process.subtitle")}
            </p>
          </div>
        </ScrollReveal>

        <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-4">
          {steps.map((step, i) => (
            <ScrollReveal key={step.titleKey} delay={i * 200} className="flex items-center gap-4">
              <div className="flex flex-col items-center text-center max-w-xs">
                {/* Blueprint-Illustration (DS-v2, TES-1086 — ersetzt Stock-Clipart) */}
                <div className="w-32 h-32 mb-4">
                  <step.Illustration
                    title={t(step.altKey)}
                    className="w-full h-full"
                    data-testid={step.testId}
                  />
                </div>
                <div className="w-20 h-20 rounded-lg bg-brand-container text-brand-container-foreground flex items-center justify-center mb-4 hover:scale-110 transition-transform">
                  <step.icon className="h-10 w-10" />
                </div>
                <div className="text-sm font-bold text-primary mb-1">
                  {t("landing.process.stepLabel", { number: i + 1 })}
                </div>
                <h3 className="text-lg font-semibold text-foreground mb-2">{t(step.titleKey)}</h3>
                <p className="text-sm text-muted-foreground">{t(step.descKey)}</p>
              </div>
              {i < steps.length - 1 && (
                <ArrowRight className="hidden md:block h-8 w-8 text-primary/40 flex-shrink-0 landing-pulse-arrow" />
              )}
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
